<template>
  <div class="mmain" v-title data-title="北京天蔚中医药发展促进中心-项目详情">
    <div class="program">
      <div class="showSomeProgram">
        <!-- <div class="pLeft">
          <img
            v-if="!programDetailData.video"
            :src="programDetailData.picture"
            alt
          />
          <div v-else class="video">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              @pause="pausePlay($event)"
              :options="playerOptions"
            ></video-player>
          </div>
        </div> -->
        <div class="pRight">
          <h1>{{ programDetailData.name }}</h1>
          <div class="pShow">
            <h5>募捐编号：</h5>
            <h4>{{ programDetailData.itemserial }}</h4>
          </div>
          <div class="pShow">
            <h5>募捐时间：</h5>
            <h4>{{ programDetailData.donatime }}</h4>
          </div>
          <div class="pBox">
            <h5>募捐目标（元）：</h5>
            <h3>{{ programDetailData.placement }}</h3>
          </div>
          <div class="pWrapper">
            <div class="pOneBox">
              <h4>{{ programDetailData.raisefund }}</h4>
              <h5>已募捐额（元）</h5>
            </div>
            <div class="pOneBox">
              <h4>{{ programDetailData.person }}</h4>
              <h5>个人（次）</h5>
            </div>
            <div class="pOneBox">
              <h4>{{ programDetailData.team }}</h4>
              <h5>团体（次）</h5>
            </div>
          </div>
          <div class="apply">
            <MTtile title="捐赠要求"></MTtile>
            <div class="applyContent">{{ programDetailData.donatefor }}</div>
          </div>
          <div class="line"></div>
          <div class="apply">
            <MTtile title="申请要求"></MTtile>
            <div class="applyContent">{{ programDetailData.applyfor }}</div>
          </div>
          <div class="line"></div>
          <div class="apply">
            <MTtile title="项目详情"></MTtile>
            <div
              class="applyContent"
              v-html="programDetailData.donateask"
            ></div>
          </div>
          <div class="line"></div>
        </div>
        <div class="love">
          <div class="pnav">
            <ul>
              <li
                :style="
                  index == nav.length - 1
                    ? currentIndex == index
                      ? `background-color:#0687c8;color:#fff;border-right:none;width:calc((100vw - 0.6rem)/${nav.length})`
                      : `border-right:none;width:calc((100vw - 0.6rem)/${nav.length})`
                    : currentIndex == index
                    ? `background-color:#0687c8;color:#fff;width:calc((100vw - 0.6rem)/${nav.length})`
                    : `width:calc((100vw - 0.6rem)/${nav.length})`
                "
                v-for="(item, index) in nav"
                :key="index"
                @click="changNav(item, index)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="loveHeader">
            <MTtile :title="nav[currentIndex].name"></MTtile>
          </div>
          <div v-if="currentIndex == 0" class="user">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column label="排名" align="center" min-width="5%">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                align="center"
                min-width="10%"
              ></el-table-column>
              <el-table-column
                prop="money"
                label="金额"
                align="center"
                min-width="10%"
              ></el-table-column>
              <el-table-column
                prop="donortime"
                label="时间"
                align="center"
                min-width="10%"
              ></el-table-column>
            </el-table>
          </div>
          <div v-else-if="currentIndex == 1">
            <div class="user">
              <el-table
                ref="multipleTable"
                :data="jztableData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column label="序号" align="center" min-width="5%">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 + (jzpaginations.page_index - 1) * 10 }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="捐赠人"
                  align="center"
                  min-width="10%"
                ></el-table-column>
                <el-table-column
                  prop="money"
                  label="捐赠金额"
                  align="center"
                  min-width="10%"
                ></el-table-column>
                <el-table-column
                  prop="donortime"
                  label="时间"
                  align="center"
                  min-width="10%"
                ></el-table-column>
              </el-table>
            </div>
            <div
              class="tspage"
              v-if="jzpaginations.total > jzpaginations.page_size"
            >
              <el-pagination
                background
                :pager-count="3"
                @current-change="jzhandleCurrentChange"
                :current-page.sync="jzpaginations.page_index"
                :page-size="jzpaginations.page_size"
                :total="jzpaginations.total"
                layout="prev, pager, next"
              ></el-pagination>
            </div>
          </div>
          <div v-else-if="currentIndex == 2">
            <div class="user">
              <el-table
                ref="multipleTable"
                :data="sztableData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column label="序号" align="center" min-width="5%">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 + (szpaginations.page_index - 1) * 10 }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="受助人"
                  align="center"
                  min-width="10%"
                ></el-table-column>
                <el-table-column
                  prop="money"
                  label="受助金额"
                  align="center"
                  min-width="10%"
                ></el-table-column>
                <el-table-column
                  prop="donortime"
                  label="时间"
                  align="center"
                  min-width="10%"
                ></el-table-column>
              </el-table>
            </div>
            <div
              class="tspage"
              v-if="szpaginations.total > szpaginations.page_size"
            >
              <el-pagination
                background
                :pager-count="3"
                @current-change="szhandleCurrentChange"
                :current-page.sync="szpaginations.page_index"
                :page-size="szpaginations.page_size"
                :total="szpaginations.total"
                layout="prev, pager, next"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from "@/components/count-to";
import { getProgramList, getJzUserList, getSzUserList } from "@/api/user.js";
import { BASE_URL, moneyFormat } from "@/utils/base.js";
import Bus from "@/utils/bus.js";
import MTtile from "@/components/MTitle.vue";
import { videoPlayer } from "vue-video-player";
export default {
  name: "mProgramDetail",
  data() {
    return {
      pnav: [],
      nav: [
        { name: "爱心榜", status: -1 },
        { name: "募捐记录", status: 2 },
        { name: "受助记录", status: 3 },
      ],
      pcurrentIndex: 0,
      realPcurrentIndex: 0,
      pscurrentIndex: 0,
      programData: {},
      jzpaginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      szpaginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      currentIndex: 0,
      tableData: [],
      jztableData: [],
      sztableData: [],
      programDetailData: {},
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
    };
  },
  created() {
    this.getOneProgram();
    this.getJzList();
    this.getSzList();
    this.getLove();
  },
  mounted() {
    window.scrollTo({
      top: 0,
    });
    this.$nextTick(function () {
      Bus.$emit("getpCurrent", "mHzzx");
    });
  },
  methods: {
    // 获取项目详情
    async getOneProgram() {
      let programId = new FormData();
      programId.append("sids", this.$route.params.id);
      let programDetail = await getProgramList(programId);
      this.programDetailData = programDetail;
      if (this.programDetailData.video) {
        this.programDetailData.video = BASE_URL + this.programDetailData.video;
        this.playerOptions.sources[0].src = this.programDetailData.video;
      }
      if (this.programDetailData.picture) {
        this.programDetailData.picture =
          BASE_URL + this.programDetailData.picture;
      }
      this.programDetailData.bili = Number(
        (
          (this.programDetailData.raisefund /
            this.programDetailData.placement) *
          100
        ).toFixed(2)
      );
      this.programDetailData.raisefund = moneyFormat(
        this.programDetailData.raisefund,
        2
      );
      this.programDetailData.placement = moneyFormat(
        this.programDetailData.placement,
        2
      );
      this.programDetailData.person = moneyFormat(
        this.programDetailData.person,
        0
      );
      this.programDetailData.team = moneyFormat(this.programDetailData.team, 0);
    },
    // 切换榜单
    changNav(item, index) {
      this.currentIndex = index;
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      };
      // this.getProgram();
    },
    // 获取爱心榜列表
    async getLove() {
      let userList = new FormData();
      // userList.append("dentity", this.dentityNav[this.dentityIndex]);
      userList.append("page", 1);
      userList.append("rows", 10);
      userList.append("keyword", this.$route.params.id);
      userList.append("sids", 2);
      userList.append("school", "金额");
      let listInfo = await getJzUserList(userList);
      this.paginations.total = listInfo.total;
      this.tableData = listInfo.rows;
      this.tableData.map((item) => {
        item.donortime = item.donortime.substring(0, 10);
      });
    },
    // 获取捐赠人员列表
    async getJzList() {
      let userList = new FormData();
      // userList.append("dentity", this.dentityNav[this.dentityIndex]);
      userList.append("page", this.jzpaginations.page_index);
      userList.append("rows", this.jzpaginations.page_size);
      userList.append("keyword", this.$route.params.id);
      userList.append("xueyuan", 2);
      let listInfo = await getJzUserList(userList);
      this.jzpaginations.total = listInfo.total;
      this.jztableData = listInfo.rows;
      this.jztableData.map((item) => {
        item.donortime = item.donortime.substring(0, 10);
      });
    },
    // 获取受助人员列表
    async getSzList() {
      let userList = new FormData();
      userList.append("page", this.szpaginations.page_index);
      userList.append("rows", this.szpaginations.page_size);
      userList.append("keyword", this.$route.params.id);
      userList.append("xueyuan", 2);
      let listInfo = await getSzUserList(userList);
      this.szpaginations.total = listInfo.total;
      this.sztableData = listInfo.rows;
      this.sztableData.map((item) => {
        item.donortime = item.donortime.substring(0, 10);
      });
    },
    pausePlay(player) {
      //关闭弹窗-停止播放
      this.player.pause();
    },
    // 表格序号
    szindexMethod(index) {
      return index + (this.szpaginations.page_index - 1) * 10 + 1;
    },
    indexMethod(index) {
      return index + (this.paginations.page_index - 1) * 10 + 1;
    },
    jzindexMethod(index) {
      return index + (this.jzpaginations.page_index - 1) * 10 + 1;
    },
    // 分页
    szhandleCurrentChange(val) {
      this.szpaginations.page_index = val;
      this.getSzList();
    },
    // 分页
    jzhandleCurrentChange(val) {
      this.jzpaginations.page_index = val;
      this.getJzList();
    },
  },
  computed: {
    // 视频
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  components: { CountTo, videoPlayer, MTtile },
};
</script>
<style lang="less" scoped>
.mmain {
  margin-top: 150px;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 80px;
  .program {
    width: calc(100vw - 60px);
    background-color: #fff;
    margin: 0 auto;
    .showSomeProgram {
      width: 100%;
      .pRight {
        width: 100%;
        h1 {
          width: 90%;
          font-size: 32px;
          font-weight: 600;
          color: #333;
          margin-bottom: 60px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;
        }
        .pShow {
          display: flex;
          font-size: 16px;
          font-size: 28px;
          margin-bottom: 30px;
          color: #666;
        }
        .pBox {
          width: 100%;
          height: 136px;
          background-color: #f5f5f5;
          border-radius: 10px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          h5 {
            font-size: 28px;
            color: #333;
            margin-left: 30px;
          }
          h3 {
            color: #0687c8;
            font-size: 36px;
            font-weight: 600;
          }
        }
        .pWrapper {
          width: 100%;
          height: 136px;
          background-color: #f5f5f5;
          border-radius: 10px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: space-around;
          .pOneBox {
            text-align: center;
            font-size: 28px;
            h5 {
              color: #333;
              margin-left: 30px;
            }
            h4 {
              color: #0687c8;
              line-height: 2;
              font-weight: 600;
            }
          }
        }

        .apply {
          padding: 40px 0;
          color: #333;
          font-size: 28px;
          line-height: 2;
          .applyContent {
            margin-top: 30px;
          }
        }
        .line {
          width: 100vw;
          margin-left: -30px;
          height: 1px;
          background-color: #ebebeb;
        }
      }
      .love {
        padding: 40px 0;
        .pnav {
          height: 60px;
          width: 100%;
          margin: 0 auto;
          border: 1px solid #ccc;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 10px;
          overflow: hidden;

          ul {
            display: flex;
            height: 60px;
            justify-content: center;
            li {
              font-size: 30px;
              color: #333;
              height: 60px;
              text-align: center;
              line-height: 60px;
              border-right: 1px solid #cccccc;
              cursor: pointer;
            }
          }
        }
        .loveHeader {
          margin: 40px 0 30px;
        }
        .user {
          font-size: 30px;
          /deep/ .el-table th {
            background-color: #ebebeb;
            color: #3b3b3b;

            .cell {
              font-size: 30px;
            }
          }
          /deep/ .el-table tr {
            font-size: 30px;
            .cell {
              padding: 24px 0;
            }
          }
        }
        .tspage {
          margin-top: 40px;
          text-align: center;
          /deep/.el-pagination.is-background
            .el-pager
            li:not(.disabled).active {
            background-color: #0687c8;
            border: none;
          }
          /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
            background-color: #fff; // 进行修改未选中背景和字体
            padding: 0 14px;
            font-size: 26px;
            height: 50px;
            line-height: 50px;
            margin: 0 10px;
            // color: #fff;
          }
          /deep/ .el-pagination.is-background button {
            background-color: #fff; // 进行修改未选中背景和字体
            border: 1px solid #ededed;
            font-size: 26px;
            height: 50px;
            line-height: 50px;
            padding: 0 10px;
            // color: #fff;
          }
        }
      }
    }
    .ProgramDetail {
      width: 100%;
      margin: 30px auto;
      .pDetailLeft {
        width: 100%;
        .pDetailLeftContent {
          margin: 0 20px;
          padding: 20px 0;
          h2 {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 20px;
          }
          .pContent {
            line-height: 2;
          }
        }
      }
      .pDetailRight {
        .love {
          margin-bottom: 20px;
          width: 380px;
          border: 1px solid #dedede;
          border-radius: 5px;
          .loveContent {
            width: 320px;
            margin: 20px 30px;
            .loveHeader {
              width: 320px;
              height: 50px;
              background: url("../assets/paihang.png");
              background-size: 320px 50px;
              h3 {
                width: 320px;
                font-size: 20px;
                color: #fff;
                text-align: center;
                padding-top: 8px;
              }
            }
            .tspage {
              margin: 30px 0 20px;
              text-align: center;
              /deep/.el-pagination.is-background
                .el-pager
                li:not(.disabled).active {
                background-color: #0687c8;
                border: none;
              }
              /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
                background-color: #fff; // 进行修改未选中背景和字体
                border: 1px solid #ededed;
                // color: #fff;
              }
              /deep/ .el-pagination.is-background button {
                background-color: #fff; // 进行修改未选中背景和字体
                border: 1px solid #ededed;
                // color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>